import { Grid } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { Tab, TabContainer } from "@saleor/components/Tab";
import { CoverDetails_cover } from "@saleor/cover/types/CoverDetails";
import DiscountCategories from "@saleor/discounts/components/DiscountCategories";
import DiscountProducts from "@saleor/discounts/components/DiscountProducts";
// import { CoverDetailsFragment } from "@saleor/fragments/types/CoverDetailsFragment";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { UserError } from "@saleor/types";
import { ListProps, TabListActions } from "@saleor/types";
import { CoverCoverType } from "@saleor/types/globalTypes";
import { concat } from "lodash-es";
import React from "react";
import { useIntl } from "react-intl";

import CoverDetails from "../CoverDetails";

export enum CoverDetailsPageTab {
  categories = "categories",
  products = "products"
}

export interface CoverPageFormData {
  name?: string | null;
  title?: string | null;
  coverType: CoverCoverType;
  subtitle?: string | null;
  firstImagePc?: string | null;
  firstImageMb?: string | null;
  firstImageLink?: string | null;
  secondImagePc?: string | null;
  secondImageMb?: string | null;
  secondImageLink?: string | null;
  thirdImagePc?: string | null;
  thirdImageMb?: string | null;
  thirdImageLink?: string | null;
  fourthImagePc?: string | null;
  fourthImageMb?: string | null;
  fourthImageLink?: string | null;

  firstImageText?: string | null;
  secondImageText?: string | null;
  thirdImageText?: string | null;
  fourthImageText?: string | null;

  detailImagePc?: string | null;
  detailImageMb?: string | null;
  detailImageLink?: string | null;
  detailImageText?: string | null;
  detailLinkTargetPc?: string | null;
  detailLinkTargetMb?: string | null;

  // products?: Array<string | null> | null;
  // categories?: Array<string | null> | null;
}

export interface CoverPageProps
  extends Pick<ListProps, Exclude<keyof ListProps, "onRowClick">>,
    TabListActions<"categoryListToolbar" | "productListToolbar"> {
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onDelete?: () => void;
  onSubmit: (data: CoverPageFormData) => void;
  errors: UserError[];
  isNew: boolean;
  // cover所在集合
  activeTab?: CoverDetailsPageTab;
  onTabClick?: (index: CoverDetailsPageTab) => void;
  cover: CoverDetails_cover;
  onCategoryAssign?: () => void;
  onCategoryUnassign?: (id: string) => void;
  onCategoryClick?: (id: string) => () => void;
  onProductAssign?: () => void;
  onProductUnassign?: (id: string) => void;
  onProductClick?: (id: string) => () => void;
  onRemove?: () => void;
}

const CoverPage: React.FC<CoverPageProps> = ({
  cover,
  disabled,
  saveButtonBarState,
  onBack,
  onDelete,
  onSubmit,
  errors,
  isNew,
  // cover所在集合
  onTabClick,
  activeTab,
  onCategoryAssign,
  onCategoryClick,
  onCategoryUnassign,
  onNextPage,
  onPreviousPage,
  onProductAssign,
  onProductClick,
  onProductUnassign,
  // onRemove,
  pageInfo,
  categoryListToolbar,
  productListToolbar,
  isChecked,
  selected,
  toggle,
  toggleAll
}) => {
  const intl = useIntl();
  const initialForm: CoverPageFormData =
    cover === null
      ? {
          name: "",
          coverType: CoverCoverType.FOUR_MAP_MASK,
          title: "",
          subtitle: "",
          firstImagePc: "",
          firstImageMb: "",
          firstImageLink: "",
          secondImagePc: "",
          secondImageMb: "",
          secondImageLink: "",
          thirdImagePc: "",
          thirdImageMb: "",
          thirdImageLink: "",
          fourthImagePc: "",
          fourthImageMb: "",
          fourthImageLink: "",
          firstImageText: "",
          secondImageText: "",
          thirdImageText: "",
          fourthImageText: "",
          detailImagePc: "",
          detailImageMb: "",
          detailImageLink: "",
          detailImageText: "",
          detailLinkTargetPc: "",
          detailLinkTargetMb: ""
        }
      : {
          name: maybe(() => cover.name, ""),
          coverType: maybe(() => cover.coverType, CoverCoverType.FOUR_MAP_MASK),
          title: maybe(() => cover.title, ""),
          subtitle: maybe(() => cover.subtitle, ""),
          firstImagePc: maybe(() => cover.firstImagePc, ""),
          firstImageMb: maybe(() => cover.firstImageMb, ""),
          firstImageLink: maybe(() => cover.firstImageLink, ""),
          secondImagePc: maybe(() => cover.secondImagePc, ""),
          secondImageMb: maybe(() => cover.secondImageMb, ""),
          secondImageLink: maybe(() => cover.secondImageLink, ""),
          thirdImagePc: maybe(() => cover.thirdImagePc, ""),
          thirdImageMb: maybe(() => cover.thirdImageMb, ""),
          thirdImageLink: maybe(() => cover.thirdImageLink, ""),
          fourthImagePc: maybe(() => cover.fourthImagePc, ""),
          fourthImageMb: maybe(() => cover.fourthImageMb, ""),
          fourthImageLink: maybe(() => cover.fourthImageLink, ""),
          firstImageText: maybe(() => cover.firstImageText, ""),
          secondImageText: maybe(() => cover.secondImageText, ""),
          thirdImageText: maybe(() => cover.thirdImageText, ""),
          fourthImageText: maybe(() => cover.fourthImageText, ""),
          detailImagePc: maybe(() => cover.detailImagePc, ""),
          detailImageMb: maybe(() => cover.detailImageMb, ""),
          detailImageLink: maybe(() => cover.detailImageLink, ""),
          detailImageText: maybe(() => cover.detailImageText, ""),
          detailLinkTargetPc: maybe(() => cover.detailLinkTargetPc, ""),
          detailLinkTargetMb: maybe(() => cover.detailLinkTargetMb, "")
        };

  const handleSubmit = (data: CoverPageFormData) =>
    onSubmit({
      ...data
    });
  const CategoriesTab = Tab(CoverDetailsPageTab.categories);
  const ProductsTab = Tab(CoverDetailsPageTab.products);

  return (
    <>
      <Form initial={initialForm} onSubmit={handleSubmit}>
        {({ change, data, hasChanged, setNameValue, submit }) => (
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.cover)}
            </AppHeader>
            <PageHeader
              title={
                cover === null
                  ? intl.formatMessage({
                      defaultMessage: "Create New Plugin",
                      description: "page title"
                    })
                  : maybe(() => concat("Plugin: ", cover.name))
              }
            />
            <Grid>
              <div>
                <CoverDetails
                  data={data}
                  disabled={disabled}
                  onChange={change}
                  errors={errors}
                  isNew={isNew}
                  setNameValue={setNameValue}
                />
              </div>
              <FormSpacer />
              {!!!isNew && (
                <>
                  <TabContainer>
                    <CategoriesTab
                      isActive={activeTab === CoverDetailsPageTab.categories}
                      changeTab={onTabClick}
                    >
                      {intl.formatMessage(
                        {
                          defaultMessage: "Categories ({quantity})",
                          description: "number of categories"
                        },
                        {
                          quantity: maybe(
                            () => cover.categories.totalCount.toString(),
                            "…"
                          )
                        }
                      )}
                    </CategoriesTab>
                    <ProductsTab
                      isActive={activeTab === CoverDetailsPageTab.products}
                      changeTab={onTabClick}
                    >
                      {intl.formatMessage(
                        {
                          defaultMessage: "Products ({quantity})",
                          description: "number of products"
                        },
                        {
                          quantity: maybe(
                            () => cover.products.totalCount.toString(),
                            "…"
                          )
                        }
                      )}
                    </ProductsTab>
                  </TabContainer>
                  <CardSpacer />
                  {activeTab === CoverDetailsPageTab.categories ? (
                    <DiscountCategories
                      disabled={disabled}
                      onCategoryAssign={onCategoryAssign}
                      onCategoryUnassign={onCategoryUnassign}
                      onNextPage={onNextPage}
                      onPreviousPage={onPreviousPage}
                      onRowClick={onCategoryClick}
                      pageInfo={pageInfo}
                      discount={cover}
                      isChecked={isChecked}
                      selected={selected}
                      toggle={toggle}
                      toggleAll={toggleAll}
                      toolbar={categoryListToolbar}
                    />
                  ) : (
                    <DiscountProducts
                      disabled={disabled}
                      onNextPage={onNextPage}
                      onPreviousPage={onPreviousPage}
                      onProductAssign={onProductAssign}
                      onProductUnassign={onProductUnassign}
                      onRowClick={onProductClick}
                      pageInfo={pageInfo}
                      discount={cover}
                      isChecked={isChecked}
                      selected={selected}
                      toggle={toggle}
                      toggleAll={toggleAll}
                      toolbar={productListToolbar}
                    />
                  )}
                </>
              )}
            </Grid>
            <SaveButtonBar
              disabled={disabled || !hasChanged}
              state={saveButtonBarState}
              onCancel={onBack}
              onSave={submit}
              onDelete={isNew ? undefined : onDelete}
            />
          </Container>
        )}
      </Form>
    </>
  );
};
export default CoverPage;
